export default "__VITE_ASSET__DvfPb0Q___"